<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="clearfix">
    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Nombre"
      name="displayName"
      data-vv-as="Nombre"
      placeholder="NOMBRE"
      v-model="displayName"
      class="w-full mb-5"
      autocomplete="off"
      @input="upper()" />
    <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>


    <ejs-dropdownlist
      :dataSource="options3"
      :fields="selectionFields"
      v-model="select3"
      class="w-full "
      :select="changeIdentification"
    ></ejs-dropdownlist>


    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      :label-placeholder= this.rucced
      name="Identificacion"
      :data-vv-as="this.rucced"
      v-model="identification"
      class="w-full"
      @input="upper()" />
    <span class="text-danger text-sm">{{ errors.first('Identificacion') }}</span>


    <ejs-dropdownlist
      placeholder="CLASE"
      :allowFiltering='allowFiltering' 
      :filtering='filteringClase'
      :dataSource="clases"
      :fields="selectionFieldsClase"
      v-model="clas"
      class="w-full"
      v-validate="'required'"
      data-vv-validate-on="blur"
      name="clase"
      data-vv-as="Clase"
      floatLabelType="Auto"
    ></ejs-dropdownlist>
    <span class="text-danger text-sm">{{ errors.first('clase') }}</span>

    <ejs-dropdownlist
      placeholder="ZONA"
      :allowFiltering='allowFiltering' 
      :filtering='filteringZona'
      :dataSource="zonas"
      :fields="selectionFieldsZona"
      v-model="Zon"
      class="w-full"
      v-validate="'required'"
      data-vv-validate-on="blur"
      name="zona"
      data-vv-as="Zona"
      floatLabelType="Auto"
    ></ejs-dropdownlist>
    <span class="text-danger text-sm">{{ errors.first('zona') }}</span>

    <vs-input
      data-vv-validate-on="blur"
      label-placeholder= "DIRECCIÓN"
      name="direccion"
      v-model="Dir"
      @input="upper()"
      class="w-full" />
    <!-- <span class="text-danger text-sm">{{ errors.first('Identificacion') }}</span> -->

    <vs-input
      data-vv-validate-on="blur"
      label-placeholder= "TELEFONO"
      name="telefono"
      v-model="Tel"
      class="w-full"
      @input="upper()" />

    <vs-input
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="EMAIL"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required'"
      name="password"
      data-vv-as="Contraseña"
      label-placeholder="Password"
      placeholder="CONTRASEÑA"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
      type="password"
      v-validate="'confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="Contraseña"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="CONFIRMAR CONTRASEÑA"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

    <!-- <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox> -->
    <vs-button class=" mt-6" @click="registerClient" :disabled="!validateForm">REGISTRARSE</vs-button>
    <vs-button  type="border" to="/pages/login" class="float-right mt-6">INGRESAR</vs-button>
    
  </div>
</template>

<script>
import axios from "axios";
import auth from '@/auth/authService'
import Vue from "vue";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DataManager,Query,ODataV4Adaptor,Predicate } from "@syncfusion/ej2-data";
import {mapState, mapActions} from 'vuex'

Vue.use(DropDownListPlugin);
var codemp = localStorage.getItem("codemp")

export default {
  data () {
    return {
      allowFiltering: true,
      selectionFields: { text: "text", value: "value" },
      selectionFieldsClase: { text: "label", value: "codcla" },
      selectionFieldsZona: { text: "fullzona", value: "codzona" },
      displayName: '',
      email: '',
      password: '',
      confirm_password: '',
      identification: '',
      clas: '',
      Zon: '',
      Dir: '',
      Tel: '',
      // isTermsConditionAccepted: true,
      select3: 'R',
      options3: [
        { text: 'CEDULA', value: 'C' },
        { text: 'RUC', value: 'R' },
        { text: 'PASAPORTE', value: 'P' },
      ],
      rucced: 'RUC',
      clases: [],
      zonas: [],
      itemsClient: {},
    }
  },
  computed: {
    ...mapState('eCommerce', ['claseState', 'zonaState']),
    validateForm () {
      return !this.errors.any() 
      && this.displayName !== '' 
      && this.identification !== ''
      && this.clas !== ''
      && this.Zon !== ''
      && this.password !== '' 
      && this.confirm_password !== ''
    }
  },
  mounted: function() {
    this.getClases();
    this.getZonas();
  },
  methods: {
    ...mapActions('eCommerce', ['getClaseState', 'getZonaState']),
    filteringClase: function(e) {
      var query = new Query();
      query = (e.text != "") ? query.where("label", "contains", e.text, true) : query;
      e.updateData(this.clases, query);
    },
    filteringZona: function(e) {
      var query = new Query();
      query = (e.text != "") ? query.where("fullzona", "contains", e.text, true) : query;
      e.updateData(this.zonas, query);
    },
    changeIdentification(event) {
      var a = event.itemData.value
      if(a == 'R'){
        this.rucced = 'RUC';
      }else if(a == 'C'){
        this.rucced = 'CEDULA';
      }else if(a == 'P'){
        this.rucced = 'PASAPORTE';
      }
    },
    getClases: function() {
      this.getClaseState(codemp).then(response => {
        this.clases = this.claseState;
      })
    },
    getZonas: function() {
      this.getZonaState(codemp).then(response => {
        this.zonas = this.zonaState;
      })
    },
    registerClient () {

      this.itemsClient.codemp = codemp;
      this.itemsClient.codcla = this.clas;
      this.itemsClient.apliva = 1;
      this.itemsClient.nomcli = this.displayName;
      this.itemsClient.rucced = this.identification;
      this.itemsClient.dircli = this.Dir;
      this.itemsClient.telcli = this.Tel;
      this.itemsClient.mail = this.email;
      this.itemsClient.tiprucced = this.select3;
      this.itemsClient.codzona = this.Zon;
      this.itemsClient.estado = 'S';
      this.itemsClient.especial = 'R';
      this.itemsClient.forpag = 'A';
      this.itemsClient.clasuj = 'N';
      this.itemsClient.codretret = 312;
      this.itemsClient.codretiva = 725;
      this.itemsClient.clipsw = this.password;

      axios.post(''+auth.connectionFrontEnd()+'/webapi/registrarClienteEC',
      {
          codemp: codemp,
          rucced: this.identification,
          dataClient: this.itemsClient
        }
      ).then(response => {

        if(response.data.success == true){
          this.$vs.notify({
                title: 'Cliente Registrado',
                text: 'Cliente Registrado correctamente',
                iconPack: 'feather',
                icon: 'icon-save',
                color: 'success'
          }); 
          localStorage.clear(); 
          sessionStorage.clear(); 
          this.$router.push({  
            name: "page-login"  
          }); 
        } else{
          this.$vs.notify({
              title: 'Error',
              text: 'Cliente ya registrado intente con otro número de identificación',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
        }   
      }).catch(e => {
        this.$vs.notify({
            title: 'Error',
            text: 'Problema con el Servidor, Intente más tarde',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
      })
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    registerUserJWt () {
      // If form is not validated or user is already login return
      if (!this.validateForm || !this.checkLogin()) return

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          password: this.password,
          confirmPassword: this.confirm_password
        },
        notify: this.$vs.notify
      }
      this.$store.dispatch('auth/registerUserJWT', payload)
    },
    upper() {
        this.displayName = this.displayName.toUpperCase();
        this.identification = this.identification.toUpperCase();
        this.Dir = this.Dir.toUpperCase();
        this.Tel = this.Tel.toUpperCase();
    }
  }
}
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
</style>